import axios from "axios";
import store from "@/store";

// AxiosAuth
export const axiosAppsAuth = axios.create({
	baseURL: `${process.env.VUE_APP_API_SERVER}/auth`,
	headers: {
		Authorization: `Bearer ${store.getters.getToken}`,
	},
});
